var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDice28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.436 2.776a3.887 3.887 0 0 0-3.66 3.66C2.643 8.716 2.5 11.701 2.5 14c0 2.299.143 5.283.276 7.564a3.887 3.887 0 0 0 3.66 3.66c2.28.133 5.265.276 7.564.276 2.299 0 5.283-.143 7.564-.276a3.887 3.887 0 0 0 3.66-3.66c.133-2.28.276-5.265.276-7.564 0-2.299-.143-5.283-.276-7.564a3.887 3.887 0 0 0-3.66-3.66C19.284 2.643 16.299 2.5 14 2.5c-2.299 0-5.283.143-7.564.276ZM21 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-7 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice28);
export default __webpack_public_path__ + "static/media/dice_28.b259198c.svg";
export { ForwardRef as ReactComponent };